import { render, staticRenderFns } from "./TheDeliveries.vue?vue&type=template&id=327aaec2&"
import script from "./TheDeliveries.vue?vue&type=script&lang=js&"
export * from "./TheDeliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports